import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import "../../styles/centralised-plan/plan-features.css";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { selectToken } from "../auth/auth.selector";
import {
  commonPostPutApi,
  fetchApiData,
} from "../../redux/reducers/commonApiSlice";
import {
  addCentralisedPlanFeature,
  centralisedPlanFeatures,
  deleteCentralisedPlanFeature,
  updateCentralisedPlanFeature,
} from "../../data/ApiEndpoints";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";

const AddFeature = ({ onCloseModal, rowData }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const { data, loading } = useSelector((state) => state.common);

  const featureInitials = [];
  const [featuresArray, setFeaturesArray] = useState([featureInitials]);
  const [formErrors, setFormErrors] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isPrevPlans, setIsPrevPlans] = useState(false);

  const inifilter = {
    page: 1,
    limit: 10,
    duration: rowData?.duration || 0,
    is_allgym_access: rowData?.is_allgym_access ? 1 : 0,
  };
  const [filters, setFilters] = useState(inifilter);

  const onCloseModalInner = () => {
    setFeaturesArray([featureInitials]);
    setFormErrors([]);
    setIsSubmit(false);
    setIsPrevPlans(false);
    setFilters(inifilter);
    onCloseModal();
  };

  const onChangeInput = (e, index) => {
    const { name, value } = e.target;

    const featureErrors = validateIndividualFeature(name, value);

    setFeaturesArray((prevFeatures) => {
      return prevFeatures.map((feature, idx) => {
        if (idx === index) {
          return {
            ...feature,
            [name]: value,
          };
        }
        return feature;
      });
    });

    setFormErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = featureErrors;
      return newErrors;
    });
  };

  const addMore = (e) => {
    e.preventDefault();
    setFeaturesArray([...featuresArray, { feature_name: "" }]);
  };

  const handleSubmit = () => {
    setIsSubmit(true);
  };

  const deleteFeature = (e, index, featureUid) => {
    e.preventDefault();

    if (isPrevPlans && featureUid) {
      const filter = { uid: featureUid };
      handleDeleteDietPlan(filter);
    } else {
      setFeaturesArray((prevFeatures) =>
        prevFeatures.filter((_, idx) => idx !== index)
      );
    }
  };

  const validateIndividualFeature = (name, value) => {
    const errors = [];

    if (name === "feature_name") {
      if (value.trim() === "") {
        errors.push("Feature name is required");
      } else if (value.length > 50) {
        errors.push("Feature name cannot exceed 50 characters");
      }
    }

    const allEmpty = errors.every((arr) => arr.length === 0);

    return allEmpty ? null : errors;
  };

  const handleDeleteDietPlan = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: token,
              endpoint: deleteCentralisedPlanFeature,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Feature is deleted successfully!"
            );
            dispatch(
              fetchApiData({
                method: "GET",
                endpoint: centralisedPlanFeatures,
                payload: {
                  filters: filters,
                },
                token: token,
              })
            );
          } else {
            toast.error(response?.message || "Can not delete Feature!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Feature");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this Feature!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  const handleAdd = async (requestBody) => {
    const method = isPrevPlans && rowData?.uid ? "PUT" : "POST";
    const endpoint =
      isPrevPlans && rowData?.uid
        ? updateCentralisedPlanFeature
        : addCentralisedPlanFeature;
    const payload = requestBody;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("result> ", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        onCloseModalInner();
        dispatch(
          fetchApiData({
            method: "GET",
            endpoint: centralisedPlanFeatures,
            payload: {
              filters: filters,
            },
            token: token,
          })
        );
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({ ...prevs, duration: rowData?.duration }));
  }, []);

  useEffect(() => {
    if (filters?.duration && filters?.page && filters?.limit) {
      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: centralisedPlanFeatures,
          payload: {
            filters: filters,
          },
          token: token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    const allEmpty = formErrors?.every((arr) =>
      arr ? arr.length === 0 : true
    );

    if (isSubmit && allEmpty) {
      const requestBody = {
        feature_bulk_data: featuresArray.map((feature) => ({
          uid: isPrevPlans && feature?.uid ? feature.uid : "",
          feature_name: feature.feature_name,
          duration: rowData?.duration,
          is_allgym_access: rowData?.is_allgym_access ? 1 : 0,
        })),
      };

      handleAdd(requestBody);
    }
  }, [isSubmit, formErrors]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setFeaturesArray(data.data);
      setIsPrevPlans(true);
    } else {
      setFeaturesArray([featureInitials]);
      setIsPrevPlans(false);
    }
  }, [data]);

  return (
    <div className="centralised-feature-container">
      <ModalHeadAndClose
        title={`${rowData?.plan_name?.replace(/_/g, " ") || ""}(${
          rowData?.duration || 0
        } Days) Plan Features`}
        onClose={onCloseModalInner}
      />
      <div className="grayLine"></div>

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <form className="formContainer">
          {featuresArray.map((featureData, index) => (
            <div key={index} className="formInputsGrid twoGridSystem">
              <div className="formInputBox span2">
                <label htmlFor="feature_name" className={`formInputLabel`}>
                  Feature {index + 1} (Max 50 Characters -{" "}
                  {featureData.feature_name?.length}) *
                </label>

                <div className="multi-row-features">
                  <textarea
                    name="feature_name"
                    className={`formInput ${
                      formErrors[index]?.length ? "formError" : ""
                    }`}
                    placeholder="Enter Feature"
                    value={featuresArray[index].feature_name || ""}
                    onChange={(e) => onChangeInput(e, index)}></textarea>

                  <div className="action-btns-container">
                    {!isPrevPlans && featuresArray?.length !== 1 ? (
                      <button
                        className="action-btn delete-btn"
                        type="button"
                        onClick={(e) =>
                          deleteFeature(e, index, featureData?.uid)
                        }>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash3-fill"
                          viewBox="0 0 16 16">
                          <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                        </svg>
                      </button>
                    ) : null}

                    {featuresArray?.length === 0 ||
                    (index === featuresArray?.length - 1 &&
                      featuresArray?.length < 3) ? (
                      <button
                        className="action-btn add-btn"
                        type="button"
                        onClick={addMore}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-circle"
                          viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                        </svg>
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="formButtons" style={{ justifyContent: "flex-end" }}>
            <Button className="saveBtn" variant="danger" onClick={handleSubmit}>
              {isPrevPlans ? "Update Plan Feature" : "Add Plan Feature"}
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddFeature;
